import { render, staticRenderFns } from "./laptop.vue?vue&type=template&id=1cf78102"
import script from "./laptop.vue?vue&type=script&lang=js"
export * from "./laptop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports